// 世界觀
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Axios from '@/shared/api/axios';
import PaginationDot from '@/components/ui/PaginationDot'
import { useTranslation } from 'react-i18next';

import placeholder_portrait_40x40 from "@/assets/imgs/placeholders/portrait_40x40.png";
import IdolAvatar from '@/components/ui/IdolAvatar';
import IdolName from '@/components/ui/IdolName';
import { formatDateTime } from '@/shared/utils/formatDate';
import StatusModal from '@/components/ui/StatusModal';


const WorldView = (props) => {

    const { t } = useTranslation();

    const idolId = useSelector((state) => state.user.idolId);

    const [pageParams, setPageParams] = useState({
        idol_id: idolId,
        world_id: props.worldId, // 從 props 取得 world_id
        page: 1,
        limit: 3,
    });

    const { updateInfo } = props;
    const [idolList, setIdolList] = useState(null);
    const [total, setTotal] = useState(null);

    // API 非成功狀態碼統一由 StatusModal 顯示（含攔截器附加的 HTTP_xxx）
    const statusModalRef = useRef(null);
    const [currentStatusCode, setCurrentStatusCode] = useState('');

    const getIdolList = async (params) => {
        try {
            const res = await Axios.post("/world/get-idol-list", params);
            switch (res.data.status_code) {
                case 'SYSTEM_1000':
                    setIdolList(res.data.data);
                    setTotal(res.data.total);
                    break;
                default:
                    setCurrentStatusCode(res.data.status_code);
                    statusModalRef.current?.show();
                    break
            }
        } catch (error) {
            // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
            if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
                setCurrentStatusCode(error.httpErrorCode);
                statusModalRef.current?.show();
            } else if (!error.httpErrorCode) {
                console.error('Get world idol list error:', error);
            }
        }
    };

    const handleLink = async () => {
        try {
            const res = await Axios.post("/world/link-or-unlink", {
                idol_id: idolId,
                world_id: props.worldId // 使用從 props 傳入的 world_id
            });
            switch (res.data.status_code) {
                case 'SYSTEM_1000':
                    updateInfo();
                    break;
                default:
                    setCurrentStatusCode(res.data.status_code);
                    statusModalRef.current?.show();
                    break
            }
        } catch (error) {
            // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
            if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
                setCurrentStatusCode(error.httpErrorCode);
                statusModalRef.current?.show();
            } else if (!error.httpErrorCode) {
                console.error('Link or unlink world error:', error);
            }
        }
    };

    const handlePageChange = (number) => {
        const newPageParams = { ...pageParams, page: number };
        setPageParams(newPageParams);
        getIdolList(newPageParams);
    }

    useEffect(() => {
        getIdolList(pageParams);
    }, [])

    return (<>
        <button type="button" className={`mb-3 btn w-100 btn-lg btn-outline-primaryF ${props.sideInfo.is_link_to_world ? 'active' : ''}`}
            onClick={handleLink}>
            {props.sideInfo.is_link_to_world ? t('followed') : t('follow')}
        </button>

        <div className="rounded p-3 border bg-white shadowA mb-3">
            <div>
                <h6>{t('founder')}</h6>
                <a href={`/idol/${props.sideInfo.idol_uuid}`} className="link-none hover-p">
                    <div className="d-flex gap-2 border-bottom pb-3 mb-3 align-items-center">
                        <IdolAvatar
                            size="sm"
                            src={props.sideInfo.idol_avatar_url || placeholder_portrait_40x40}
                            idolId={props.sideInfo.idol_id}
                            alt="User Avatar"
                        />
                        <div className="min-w-0">
                            <IdolName name={props.sideInfo.idol_nick_name} isOfficial={props.sideInfo.idol_is_official} />
                        </div>
                    </div>
                </a>
                <h6>{t("build_time")}</h6>
                <div className="d-flex gap-2 border-bottom pb-3 mb-3">
                    <p className="mb-0">{formatDateTime(props.sideInfo.world_created_at)}</p>
                </div>
                <h6>{t('world_follower_count')}</h6>
                <div className="d-flex gap-2 border-bottom pb-3 mb-3 align-items-center justify-content-between">
                    <p className="mb-0">{props.sideInfo.link_count}</p>

                </div>
                <h6>{t("idollist")}</h6>
                {idolList && idolList.length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                        {idolList.map((item) => (
                            <a key={item.id} href={`/idol/${item.idol_uuid}`} className="link-none hover-p">
                                <div className="d-flex gap-2 align-items-center">
                                    <IdolAvatar
                                        size="sm"
                                        src={item.idol_avatar_url || placeholder_portrait_40x40}
                                        idolId={item.id}
                                        alt="User Avatar"
                                    />
                                    <div className="min-w-0">
                                        <IdolName name={item.idol_nick_name} isOfficial={item.idol_is_official} />
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                ) : (
                    <div>{t('no_data')}</div>
                )}
            </div>
            {idolList && idolList.length > 0 ?
                (
                    <PaginationDot total={total} limit={pageParams.limit} currentPage={pageParams.page} onPageChange={handlePageChange} />
                ) : ('')
            }
        </div>
        {/* <button type="button" className="btn btn-outline-primaryF w-100 mb-3">Collect</button>
      <button type="button" className="btn btn-outline-primaryF w-100 mb-3">Block</button>
      <button type="button" className="btn btn-outline-primaryF w-100 mb-3">Delete</button> */}
        <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    </>
    )
}

export default WorldView